function init() {
  InitFAQAccordion();
}

function InitFAQAccordion() {
  const OpenCloseFAQ = (target) => {
    $('.faqs__accordion--item').not($(target).parent()).removeClass('expand')

    $(target).parent().toggleClass("expand")

    $('.faqs__accordion--item--header').siblings('.faqs__accordion--item--body').not($(target).siblings('.faqs__accordion--item--body')).slideUp()
    $(target).siblings('.faqs__accordion--item--body').slideToggle()
  }

  $('.faqs__accordion--item--header').on('click', function () {

    //set this clicked button to aria-expanded
    $(this).attr("aria-expanded", "true")

    //find the parent accordian, and then find all buttons under it that aren't this button and remove aria expanded
    $(this).closest(".faqs__accordion").find('.faqs__accordion--item--header').not($(this)).attr("aria-expanded", "false")

    OpenCloseFAQ(this);
  })
}

export {
  init
}